import { render, staticRenderFns } from "./category.vue?vue&type=template&id=61b8a0df&lang=pug&"
import script from "./category.vue?vue&type=script&lang=coffee&"
export * from "./category.vue?vue&type=script&lang=coffee&"
import style0 from "./category.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports